export const getDefaultState = () => {
  return {
    messageList: {}
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  messageList: function(state) {
    return state.messageList;
  },
  getMessageById: function(state) {
    return msgId => {
      return state.messageList[msgId];
    };
  }
};

const actions = {
  addMessage: function({ commit }, messageObj) {
    if (!messageObj) return null;
    commit("addMessageItem", Object.assign({}, messageObj, { id: Date.now() }));
  },
  removeMessages: function({ commit }, messageIds) {
    commit("removeMessageItems", messageIds);
  },
  clearMessages: function({ commit }) {
    commit("clearMessageList");
  }
};

// mutations
const mutations = {
  addMessageItem(state, messageObj) {
    state.messageList[messageObj.id] = messageObj;
  },
  removeMessageItems(state, messageIds) {
    messageIds.forEach(id => {
      delete state.messageList[id];
    });
  },
  clearMessageList(state) {
    state.messageList = {};
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
